import type { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdIntlD70 } from './pages'

type TIdToPageMapIntlD70 = Record<PageIdIntlD70, TPageMapValue>

export const ID_TO_PAGE_MAP_INTL_D70: TIdToPageMapIntlD70 = {
  [PageIdIntlD70.OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/offer/OfferPage').then((m) => ({
        default: m.OfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_d70/pages/offer/OfferPage'),
  },
  [PageIdIntlD70.PAYMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/payment/PaymentPage').then((m) => ({
        default: m.PaymentPage,
      })),
    ),
    preload: () => import('cohorts/intl_d70/pages/payment/PaymentPage'),
  },
  [PageIdIntlD70.CHECKOUT]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/checkout/CheckoutPage').then((m) => ({
        default: m.CheckoutPage,
      })),
    ),
    preload: () => import('cohorts/intl_d70/pages/checkout/CheckoutPage'),
  },
  [PageIdIntlD70.UPSELL]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/upsell/UpsellPage').then((m) => ({
        default: m.UpsellPage,
      })),
    ),
    preload: () => import('cohorts/intl_d70/pages/upsell/UpsellPage'),
  },
  [PageIdIntlD70.REGISTRATION]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('cohorts/intl_d70/pages/account/AccountNove8'),
  },
  [PageIdIntlD70.NAME_ENTRY]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/name/NamePage').then((m) => ({
        default: m.NamePage,
      })),
    ),
    preload: () => import('cohorts/intl_d70/pages/name/NamePage'),
  },
  [PageIdIntlD70.CERTIFICATE]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/certificate/CertificatePage').then(
        (m) => ({
          default: m.CertificatePage,
        }),
      ),
    ),
    preload: () => import('cohorts/intl_d70/pages/certificate/CertificatePage'),
  },
  [PageIdIntlD70.LEARNWORLDS_REDIRECT]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/learnWorldsRedirect/LearnWorldsRedirectPage').then(
        (m) => ({
          default: m.LearnWorldsRedirectPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_d70/pages/learnWorldsRedirect/LearnWorldsRedirectPage'),
  },
  [PageIdIntlD70.REPORT]: {
    Component: lazy(() =>
      import('cohorts/intl_d70/pages/report/ReportPage').then((m) => ({
        default: m.ReportPage,
      })),
    ),
    preload: () => import('cohorts/intl_d70/pages/report/ReportPage'),
  },
}
